import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import RangeSlider from 'shared/components/RangeSlider';

const Range = ({ disabled, min, max, step, value: input, labels, unit, onChange, onSelect }) => {
  const [value, setValue] = useState(input);
  const handleChange = (values) => {
    setValue(values[0]);
    onChange(values[0]);
  };

  useEffect(() => {
    setValue(input);
  }, [input]);

  const handleFinalChange = values => onSelect(values[0]);

  return (
    <RangeSlider
      disabled={disabled}
      min={min}
      max={max}
      step={step}
      labels={labels}
      values={[value]}
      unit={unit}
      onChange={handleChange}
      onFinalChange={handleFinalChange}
    />
  );
};

Range.propTypes = {
  disabled: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number,
  labels: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  unit: PropTypes.string,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
};

Range.defaultProps = {
  disabled: false,
  min: 0,
  max: 100,
  step: 1,
  value: 0,
  labels: [],
  unit: null,
  onChange() {},
  onSelect() {},
};

export default Range;
